$(function () {
    if ($('form#FISApprovalForm').length > 0) {
        
        $(".approved, .denied").click(function () {
            UpdateCheckboxes($(this).val());
            UpdateApproveAll();
        });

        function UpdateCheckboxes(id) {
            var approveBox = $("input.approved[value='" + id + "']").first();
            var denyBox = $("input.denied[value='" + id + "']").first();
            var detail = $(".denied-detail[data-id='" + id + "'").first();

            // If the approve box is checked, the deny box is disabled, and vice-versa
            if (approveBox.is(":checked")) {
                denyBox.prop("checked", false);
                denyBox.attr("disabled", "disabled");
                detail.addClass("d-none");
            } else if (denyBox.is(":checked")) {
                approveBox.prop("checked", false);
                approveBox.attr("disabled", "disabled");
                detail.removeClass("d-none");
            } else {
                approveBox.removeAttr("disabled");
                denyBox.removeAttr("disabled");
                detail.addClass("d-none");
            }
        }

        function UpdateApproveAll() {
            // If any rows are denied, the check all is denied. If any rows are not approved, the check all is unchecked.
            if($("input.denied:checked").length > 0 ) {
                $("#ApproveAll").prop("checked", false);
                $("#ApproveAll").attr("disabled", "disabled");
            } else if ($("input.approved:not(:checked)").length > 0) {
                $("#ApproveAll").removeAttr("disabled");
                $("#ApproveAll").prop("checked", false);
            } else {
                $("#ApproveAll").removeAttr("disabled");
            }
        }

        $("#ApproveAll").click(function () {
            var isChecked = $(this).is(":checked");

            $("input.approved").each(function () {
                $(this).prop("checked", isChecked);

                UpdateCheckboxes($(this).val());
            });
        });

        $("#ApproveButton").click(function() {
            // check to make sure that any denied rows have a denied reason set
            var isValid = true;
            $(".denied-error").addClass("d-none");

            $("input.denied:checked").each(function() {
                var id = $(this).val();
                if ($(".denied-text[data-id='" + id + "'").val().trim() == "") {
                    $(".denied-error[data-id='" + id + "'").removeClass("d-none");
                    isValid = false;
                }
            });

            if(!isValid) {
                return false;
            }

            var approveCount = $("input.approved:checked").length;
            var denyCount = $("input.denied:checked").length;

            if (approveCount == 0 && denyCount == 0) {
                $("#validationModal").modal({
                    'backdrop': 'static'
                });
                return false;
            }

            var confirmString = jsAreYouSure;
            if(approveCount > 0) {
                confirmString += jsApprove.replace("X", approveCount);
            }

            if(approveCount > 0 && denyCount > 0) {
                confirmString += jsAnd
            }

            if (denyCount > 0) {
                confirmString += jsDeny.replace("X", denyCount);
            }

            confirmString += "?";

            $(".modal-body").text(confirmString);

            $("#confirmModal").modal({
                'backdrop': 'static'
            });

            return false;
        });

        $(".submit-button-modal").on('click', function (e) {
            e.stopPropagation();
            e.preventDefault();

            // Gather the approved and denied operators to send back to the server.
            var approvedList = []

            $("input.approved:checked").each(function () {
                var oper = $(this).attr("data-oper");
                
                var approvalObject = {
                    PaymentTransactionId: $(this).val(),
                    OperatorId: oper
                };

                approvedList.push(approvalObject);
            });

            // For denied operators, we need to collect the denied reasons as well.
            var deniedList = [];

            $("input.denied:checked").each(function () {
                var reason = $(".denied-text[data-id='" + $(this).val() + "'").val().trim();

                var denialObject = {
                    PaymentTransactionId: $(this).val(),
                    DeniedReason: reason
                };

                deniedList.push(denialObject);
            });
            
            // Fill out our form fields
            $("#ApprovedPaymentTransactions").val(JSON.stringify(approvedList));
            $("#DeniedPaymentTransactions").val(JSON.stringify(deniedList));

            $('#FISApprovalForm').submit();
        });

    } // if ($('form#FISApprovalForm').length > 0)
}); // $(function () {